import Cookies from 'js-cookie'

export function getToken () {
  return undefined !== Cookies.get('token') ? Cookies.get('token') : ''
}

export function setToken (token) {
  return Cookies.set('token', token)
}

export function removeToken () {
  return Cookies.remove('token')
}



// WEBPACK FOOTER //
// ./src/utils/cookie.js